// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Box, Paper, Typography } from "@mui/material";
// import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
// import { Line } from 'react-chartjs-2';
// import { useTranslation } from "react-i18next";
// import internshipIcon from "../../assets/img/internshipIcon.png";
// import { COLORS } from "colors/color";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend
// );

// const GenderDistributionChart = ({ userId }) => {
//   const apiUrl = process.env.REACT_APP_API_URL;
//   const [chartData, setChartData] = useState({ labels: [], datasets: [] });
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();
//   const { t } = useTranslation();

//   const colors = {
//     male: "#1976d2",
//     female: "#9c27b0",
//     background: "#fff",
//     text: "#1a2027",
//     grid: "#f5f5f5",
//   };

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     animation: {
//       duration: 750,
//       easing: 'easeInOutQuart'
//     },
//     plugins: {
//       legend: {
//         position: 'bottom',
//         onClick: (e, legendItem, legend) => {
//           const index = legendItem.datasetIndex;
//           const ci = legend.chart;
//           const meta = ci.getDatasetMeta(index);

//           meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

//           ci.data.datasets[index].animation = {
//             duration: 750,
//             easing: 'easeInOutQuart',
//             onComplete: () => {
//               ci.update('none');
//             },
//           };

//           ci.update('easeInOutQuart');
//         },
//         labels: {
//           padding: 20,
//           font: {
//             family: 'Poppins',
//           },
//           generateLabels: (chart) => [
//             {
//               text: t('genderChart.gender.male'),
//               fillStyle: colors.male,
//               strokeStyle: colors.male,
//               datasetIndex: 0,
//               hidden: chart.getDatasetMeta(0).hidden,
//             },
//             {
//               text: t('genderChart.gender.female'),
//               fillStyle: colors.female,
//               strokeStyle: colors.female,
//               datasetIndex: 1,
//               hidden: chart.getDatasetMeta(1).hidden,
//             },
//           ],
//         },
//       },
//       tooltip: {
//         backgroundColor: colors.background,
//         titleColor: colors.text,
//         bodyColor: colors.text,
//         borderColor: colors.grid,
//         borderWidth: 1,
//         padding: 12,
//         cornerRadius: 8,
//         boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//         callbacks: {
//           label: function(context) {
//             const label = context.dataset.label === 'Male'
//               ? t('genderChart.gender.male')
//               : t('genderChart.gender.female');
//             return `${label}: ${context.parsed.y}`;
//           }
//         }
//       },
//     },
//     scales: {
//       x: {
//         grid: {
//           display: false,
//         },
//         ticks: {
//           font: {
//             family: 'Poppins',
//           },
//           color: colors.text,
//         },
//       },
//       y: {
//         grid: {
//           color: colors.grid,
//           drawBorder: false,
//         },
//         ticks: {
//           font: {
//             family: 'Poppins',
//           },
//           color: colors.text,
//           stepSize: 1,
//         },
//         min: 0,
//       },
//     },
//   };

//   useEffect(() => {
//     const loadGenderChart = async () => {
//       try {
//         const response = await fetch(
//           `${apiUrl}recruiters/${userId}/candidates_by_gender_per_recruiter/`,
//           {
//             headers: {
//               "Content-type": "application/json",
//               Authorization: "Bearer " + localStorage.getItem("accessToken"),
//             },
//           }
//         );

//         if (response.status === 401) {
//           navigate("/login");
//           return;
//         }

//         const json = await response.json();
//         const currentMonth = new Date().getMonth();
//         const last6Months = [];

//         // Get translated month names for the last 6 months
//         for (let i = 5; i >= 0; i--) {
//           const monthIndex = (currentMonth - i + 12) % 12;
//           const translatedMonth = t(`genderChart.applications.months.${monthIndex + 1}`);
//           last6Months.push(translatedMonth);
//         }

//         // Process the data with translated months
//         const formattedData = last6Months.map(monthName => {
//           const monthNumber = String(
//             Object.keys(json).find(key =>
//               t(`genderChart.applications.months.${parseInt(key)}`) === monthName
//             )
//           );

//           const monthData = json[monthNumber] || {};
//           const maleCount = Object.values(monthData).reduce((sum, post) => sum + (post.male || 0), 0);
//           const femaleCount = Object.values(monthData).reduce((sum, post) => sum + (post.female || 0), 0);

//           return {
//             month: monthName,
//             male: maleCount,
//             female: femaleCount,
//           };
//         });

//         setChartData({
//           labels: formattedData.map(item => item.month),
//           datasets: [
//             {
//               label: t('genderChart.gender.male'),
//               data: formattedData.map(item => item.male),
//               borderColor: colors.male,
//               backgroundColor: colors.background,
//               borderWidth: 3,
//               pointBackgroundColor: colors.background,
//               pointBorderColor: colors.male,
//               pointBorderWidth: 2,
//               pointRadius: 6,
//               pointHoverRadius: 8,
//               tension: 0.4,
//               hidden: false, // Explicitly set initial visibility
//             },
//             {
//               label: t('genderChart.gender.female'),
//               data: formattedData.map(item => item.female),
//               borderColor: colors.female,
//               backgroundColor: colors.background,
//               borderWidth: 3,
//               pointBackgroundColor: colors.background,
//               pointBorderColor: colors.female,
//               pointBorderWidth: 2,
//               pointRadius: 6,
//               pointHoverRadius: 8,
//               tension: 0.4,
//               hidden: false, // Explicitly set initial visibility
//             },
//           ],
//         });
//       } catch (error) {
//         console.error("Error fetching gender data:", error);
//         setError(t('genderChart.errors.loadFailed'));
//       }
//     };

//     loadGenderChart();
//   }, [apiUrl, userId, navigate, t]);

//   if (error) {
//     return (
//       <Paper sx={{ width: "100%", p: 3, borderRadius: "20px" }}>
//         <Typography color="error">{error}</Typography>
//       </Paper>
//     );
//   }

//   return (
//     <Paper sx={{
//       borderRadius: "20px",
//       overflow: "hidden",
//       boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//       height: "480px",
//       "&:hover": {
//         boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
//       },
//     }}>
//       <Box sx={{
//         p: 3,
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center",
//         backgroundColor: colors.background
//       }}>
//         <Box>
//           <Box display="flex" alignItems="center">
//             <img src={internshipIcon} alt={t('genderChart.gender.iconAlt')} />
//             <Typography
//               variant="h5"
//               fontWeight="bold"
//               fontFamily="Poppins"
//               sx={{ color: COLORS.title_color }}
//               ml={2}
//             >
//               {t('genderChart.gender.title')}
//             </Typography>
//           </Box>
//           <Typography
//             variant="subtitle2"
//             color="text.secondary"
//             textTransform="none"
//             fontFamily="Poppins"
//           >
//             {t('genderChart.gender.subtitle')}
//           </Typography>
//         </Box>
//       </Box>
//       <Box sx={{ p: 3, height: "400px", position: "relative" }}>
//         <Line data={chartData} options={chartOptions} />
//       </Box>
//     </Paper>
//   );
// };

// export default GenderDistributionChart;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import internshipIcon from "../../assets/img/internshipIcon.png";
import { COLORS } from "colors/color";
import colors from "colors/color";
const GenderDistributionChart = ({ userId }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [percentages, setPercentages] = useState({ male: 0, female: 0 });
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const color = {
    male: colors.primary,
    female: "#fa00ff",
    background: "#fff",
  };

  useEffect(() => {
    const loadGenderData = async () => {
      try {
        const response = await fetch(
          `${apiUrl}recruiters/${userId}/candidates_by_gender_per_recruiter/`,
          {
            headers: {
              "Content-type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );

        if (response.status === 401) {
          navigate("/login");
          return;
        }

        const json = await response.json();

        // Calculate total counts
        const totalMale = Object.values(json).reduce(
          (sum, monthData) =>
            sum +
            Object.values(monthData).reduce(
              (sumPost, post) => sumPost + (post.male || 0),
              0
            ),
          0
        );

        const totalFemale = Object.values(json).reduce(
          (sum, monthData) =>
            sum +
            Object.values(monthData).reduce(
              (sumPost, post) => sumPost + (post.female || 0),
              0
            ),
          0
        );

        const total = totalMale + totalFemale;

        setPercentages({
          male: ((totalMale / total) * 100).toFixed(1),
          female: ((totalFemale / total) * 100).toFixed(1),
        });
      } catch (error) {
        console.error("Error fetching gender data:", error);
        setError(t("genderChart.errors.loadFailed"));
      }
    };

    loadGenderData();
  }, [apiUrl, userId, navigate, t]);

  if (error) {
    return (
      <Paper sx={{ width: "100%", p: 3, borderRadius: "20px" }}>
        <Typography color="error">{error}</Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{
      borderRadius: "20px",
      overflow: "hidden",
      boxShadow: "none",
      transition: "box-shadow 0.3s ease-in-out",
      height: "100%",
      border: '1px solid #D9D9D9',
      "&:hover": {
        boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
      },
    }}>
      <Box sx={{ 
        p: { xs: 2, sm: 3 }, 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center",
        backgroundColor: colors.background 
      }}>
        <Box>
          <Box display="flex" alignItems="center">
            <Typography
              sx={{
                fontFamily: "Poppins",
                fontWeight: 500,
                fontSize: { xs: '14px', sm: '16px' },
                color: '#00000080'
              }}
            >
              {t("genderChart.gender.title")}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{ p: { xs: 2, sm: 3 } }}>
        {Object.entries(percentages).map(([key, value]) => (
          <Box key={key} sx={{ mb: { xs: 2, sm: 3 } }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="body2" fontFamily="Poppins" sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                {t(`genderChart.gender.${key}`)}
              </Typography>
              <Typography variant="body2" fontFamily="Poppins" sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                {value}%
              </Typography>
            </Box>
            <Box sx={{
              height: { xs: 20, sm: 24 },
              backgroundColor: '#eeeeee',
              borderRadius: '5px',
              overflow: 'hidden'
            }}>
              <Box sx={{
                width: `${value}%`,
                height: '100%',
                backgroundColor: color[key],
                borderRadius: '5px',
                transition: 'width 0.75s ease-in-out'
              }} />
            </Box>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default GenderDistributionChart;
